export * from '../overrides/toggable';

// soon to be depricated.
import { Toggable } from '../overrides/toggable';

export default Toggable